module.exports = __webpack_public_path__ + "static/media/iCon-1024-A.2763cfd2.png";